module.exports = __webpack_public_path__ + "img/image3.fd4f87eb.jpg";